import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEOHead from '@/components/feature/SEOHead';
import HeroBanner from './components/HeroBanner';
import FeaturedSection from './components/FeaturedSection';
import LatestSection from './components/LatestSection';
import PopularSection from './components/PopularSection';
import { siteConfig } from '@/mocks/site';

const homeSchema = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '小辣椒影院-高清电影免费在线观看',
    description: siteConfig.description,
    url: siteConfig.url,
    isPartOf: {
      '@type': 'WebSite',
      name: siteConfig.name,
      url: siteConfig.url,
    },
    about: {
      '@type': 'Thing',
      name: '在线影视',
      description: '高清电影、电视剧、综艺、动漫、纪录片免费在线观看',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: '小辣椒影院',
        item: siteConfig.url,
      },
    ],
  },
];

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <SEOHead
        title={`${siteConfig.name}-高清电影免费在线观看不卡顿 | 免费影视网站高清电视剧免费全集`}
        description={siteConfig.description}
        keywords={siteConfig.keywords}
        canonicalUrl={siteConfig.url}
        schemaJsonLd={homeSchema}
      />
      <Navbar />
      <main>
        <HeroBanner />
        <FeaturedSection />
        <LatestSection />
        <PopularSection />
      </main>
      <Footer />
    </>
  );
}